import { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Card } from "primereact/card";

import UserRoleList from "./UserRoleList";
import UserRoleCreate from "./UserRoleCreate";
import { IUserRole } from "./UserRole.model";
import { userRoleService } from "../../service/UserRole/userRole.service";

const UserRole = () => {
  const [userRoleDialog, setUserRoleDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<IUserRole[]>([]);

  const openNew = () => {
    setUserRoleDialog(true);
  };

  const hideDialog = () => {
    setUserRoleDialog(false);
  };

  useEffect(() => {
    loadUserRoles();
  }, []);

  const loadUserRoles = async () => {
    setLoading(true);
    const res = await userRoleService.getAll();
    const sortedData = [...res.data].sort((a, b) => a.id - b.id);
    setData(sortedData);
    setLoading(false);
  };

  return (
    <Card>
      {/* Create Role Dialog */}
      <Dialog
        visible={userRoleDialog}
        header="Role Details"
        modal
        onHide={hideDialog}
        style={{ width: "40vw" }}>
        <UserRoleCreate
          setUserRoleDialog={setUserRoleDialog}
          loadUserRoles={loadUserRoles}
        />
      </Dialog>

      {/* Role List */}
      <UserRoleList
        openNew={openNew}
        loading={loading}
        data={data}
        loadUserRoles={loadUserRoles}
      />
    </Card>
  );
};

export default UserRole;
